import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import queryKeys from "libs/react-query/query_key";
import { queryClient } from "libs/react-query/queryClient";

import { useUserErrorCodeMap } from "./useUserErrorCodeMap";
import { getUserInquiry, putUserInquiry, getUserHeathInquiry, postUserHeathInquiry } from "./user.handler";

/** GET: 유저 문진 조회 */
export const useGetUserInquiry = ({ userId }: Partial<Parameters<typeof getUserInquiry>[0]>) => {
  const errorCodeMap = useUserErrorCodeMap();

  return useQuery({
    queryKey: queryKeys.user.inquiry(userId),
    queryFn: () => (userId ? getUserInquiry({ userId }) : Promise.resolve(undefined)),
    enabled: !!userId,
    meta: {
      errorCodeMap,
    },
  });
};

/** PUT: 유저 문진 수정 */
export const usePutUserInquiry = () => {
  const errorCodeMap = useUserErrorCodeMap();

  return useMutation({
    mutationFn: putUserInquiry,
    onSuccess: async (_, { userId }) => {
      // * 성별 및 생년월일 입력 시 성별 및 나이대 동기화
      await queryClient.invalidateQueries({ queryKey: queryKeys.user.userId(userId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.user.inquiry(userId) });
    },
    meta: {
      errorCodeMap,
    },
  });
};

/** GET: 유저 건강 문진 조회 */
export const useGetUserHealthInquiry = ({ userId }: Partial<Parameters<typeof getUserHeathInquiry>[0]>) => {
  const errorCodeMap = useUserErrorCodeMap();

  return useQuery({
    queryKey: queryKeys.user.healthInquiry(userId),
    queryFn: () => (userId ? getUserHeathInquiry({ userId }) : Promise.resolve(undefined)),
    enabled: !!userId,
    meta: {
      errorCodeMap,
    },
  });
};

/** POST: 유저 건강 문진 등록 */
export const usePostUserHealthInquiry = () => {
  const errorCodeMap = useUserErrorCodeMap();

  return useMutation({
    mutationFn: postUserHeathInquiry,
    onSuccess: async (_, { userId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.user.healthInquiry(userId) });
    },
    meta: {
      errorCodeMap,
    },
  });
};
